import inMemoryJwt from "../../auth/inMemoryJwt"
import { urlServer } from "../../config/GlobalConstant"

export const createJob = (body, history) => async dispatch => {

    await fetch(`${urlServer}joboffers/create`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: body
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                history.push("/Admin/Jobs")
            }
        })
        .catch(error => {
            console.log()
        })
}
export const listeJobs = () => async dispatch => {

    await fetch(`${urlServer}joboffers/get-all`, {
        method: 'GET', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: "GET_JOBS",
                    payload: respJson.data
                })
            }

        })
        .catch(error => {
            console.log()
        })
}


export const deleteJob = (id,close) => async dispatch => {

    await fetch(`${urlServer}joboffers/delete`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            jobOfferId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: "DELETE_JOB",
                    payload: id
                })
                close()
            }

        })
        .catch(error => {
            console.log()
        })
}
export const getJob = (id) => async dispatch => {

    await fetch(`${urlServer}joboffers/get-by-id`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: JSON.stringify({
            jobOfferId: id
        })
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: "GET_JOB",
                    payload: respJson.data
                })
            }

        })
        .catch(error => {
            console.log()
        })
}

export const editJob = (body,history) => async dispatch => {

    await fetch(`${urlServer}joboffers/update`, {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        withCredentials: true,
        credentials: 'include',
        headers: {
            'Authorization': `bearer ${inMemoryJwt.getToken()}`
            // 'Content-Type': 'application/x-www-form-urlencoded',

        }, // body data type must match "Content-Type" header    
        body: body
    })
        .then(response => response.json())
        .then(respJson => {
            if (respJson.success) {
                dispatch({
                    type: "GET_JOB",
                    payload: respJson.data
                })
                history.push("/Admin/Jobs")
            }

        })
        .catch(error => {
            console.log()
        })
}
export const clearJob = () => dispatch => {

    dispatch({
        type: "CLEAR_JOB"
    })
}

